function planUpgradeConfirmationDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/plan-upgrade-confirmation/plan-upgrade-confirmation-dialog.html?$$REVISION$$'
  }
}

export { planUpgradeConfirmationDialog }
